import Phaser from "phaser";
export default class BigTree extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y, texture, name) {
    super(scene, x, y, texture);
    this.name = name;
  }
}
